import { render, staticRenderFns } from "./UserRolesDialog.vue?vue&type=template&id=7a934ac6"
import script from "./UserRolesDialog.vue?vue&type=script&lang=js"
export * from "./UserRolesDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRolesDialog.vue?vue&type=style&index=0&id=7a934ac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports